import { dto_selected_final_merchant_or_product } from "../../classes/dto-selected-merchant-or-product";
import { dto_cart_checkout } from "../../classes/dto-cart-checkout";
import { Api, BuildVersion } from "../../config/config";
import { dto_Customer } from "../../classes/dto-customer";
import { dto_common } from "../../classes/dto-common";
import { postMethod } from "../post";

export const api_CalculationSalesOrder = (SQLDETAILSTRING, ISCHANGEPROMO) => {
  var url = `${Api}/?ControllerName104=/ApiCart`;
  var SCHEDULEDORDER = false;
  if (dto_common.SCHEDULEDDATE === "") {
    SCHEDULEDORDER = false;
  } else {
    SCHEDULEDORDER = true;
  }
  var COORDINATES = "0,0";
  if (dto_common.DineType === 3) {
    COORDINATES = dto_common.PicupCordinate;
  } else {
    COORDINATES = dto_common.CurrentCordinate;
  }

  if (
    COORDINATES === "undefined" ||
    COORDINATES === "UNDEFINED" ||
    COORDINATES === "Undefined"
  ) {
    COORDINATES = "0,0";
  }
  return postMethod(
    url,
    '{"SERVICENAME":"CalculationSalesOrder","SQLDETAILSTRING":' +
      JSON.stringify(SQLDETAILSTRING) +
      ',"MID":' +
      dto_selected_final_merchant_or_product.MID +
      ',"DISCPERCENTAGE":' +
      dto_cart_checkout.DiscountPersentage +
      ',"DDAMOUNT":' +
      dto_cart_checkout.DiscountTotal +
      ',"ZONEID":' +
      dto_common.DeliveryZoneID +
      ',"MERCHANTZONEID":' +
      parseInt(dto_selected_final_merchant_or_product.ZoneID) +
      ',"DINETYPE":' +
      dto_common.DineType +
      ',"PROMOID":' +
      dto_cart_checkout.PromoGuid +
      ',"ISCHANGEPROMO":' +
      ISCHANGEPROMO +
      ',"VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      COORDINATES +
      '", "SCHEDULEDORDER":' +
      SCHEDULEDORDER +
      ',"SCHEDULEDDATE":"' +
      dto_common.SCHEDULEDDATE +
      '","SCHEDULEDTIME":"' +
      dto_common.SCHEDULEDTIME +
      '","NIC":"' +
      dto_Customer.NIC +
      '","CSID":' +
      dto_Customer.CSID +
      "}",
  );
};

export const api_getDeliveryChargeForMIDByZone = () => {
  var url = `${Api}/?ControllerName104=/ApiCart`;
  return postMethod(
    url,
    '{"SERVICENAME":"getDeliveryChargeForMIDByZone","MID":' +
      dto_selected_final_merchant_or_product.MID +
      ',"ZONEID":' +
      dto_common.DeliveryZoneID +
      '}',
  );
};

export const api_LoadDateTimeForScheduleOrder = (
  ScheduleProductPrepareTime = 0,
) => {
  var url = `${Api}/?ControllerName104=/ApiCart`;

  return postMethod(
    url,
    '{"SERVICENAME":"LoadDateTimeForScheduleOrder","MID":' +
      dto_selected_final_merchant_or_product.MID +
      ',"VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '","DINETYPE":' +
      dto_common.DineType +
      ',"SCHEDULEPRODUCTPREPARETIME":' +
      ScheduleProductPrepareTime +
      ',"NIC":"' +
      dto_Customer.NIC +
      '","CSID":' +
      dto_Customer.CSID +
      "}",
  );
};

export const api_LoadAllPromo = (MID) => {
  var url = `${Api}/?ControllerName104=/ApiCart`;
  return postMethod(
    url,
    '{"SERVICENAME":"LoadAllPromo","CSID":' +
      dto_Customer.CSID +
      ',"DINETYPE":' +
      dto_common.DineType +
      ',"MID":' +
      MID +
      ',"VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '"}',
  );
};
